import React, { FC, useState, useRef, useEffect, RefObject } from 'react'
import Carousel from 'components/SA/Carousel/v2'
import styles from './Homepage.module.scss'
import { useSelector } from 'react-redux'
import { getCarouselData } from '../selectors'
import useQA from 'hooks/useQA'
import SeeMoreTile from 'components/ProductCarousels/SeeMoreTile'
import Polaroid from 'components/ProductCarousels/ProductCarouselPolaroid'
import { clickArtworkCarousel } from 'components/ProductCarousels/helpers'
import useCarouselImageLazyLoading from 'components/SA/Carousel/v2/useCarouselImageLazyLoading'

const ProductCarousels: FC = () => {
  const carouselsData = useSelector(getCarouselData)
  const polaroidRef = useRef<HTMLDivElement>(null)
  const [polaroidWidth, setPolaroidWidth] = useState<number>(
    polaroidRef?.current?.offsetWidth || 311
  )
  const { handleImageLazyLoading, lastImageIndexLoaded } = useCarouselImageLazyLoading({
    offset: 5,
  })
  const { testId } = useQA()
  const LIST_ID = 'product-carousel-hp-cms'

  useEffect(() => {
    if (!!polaroidRef?.current?.offsetWidth) {
      setPolaroidWidth(polaroidRef?.current?.offsetWidth)
    }
  }, [polaroidRef?.current?.offsetWidth])

  const handleClick = (ev: React.SyntheticEvent<Record<string, any>>) => {
    clickArtworkCarousel(ev)
  }
  return (
    <div className={styles.productCarousels} {...testId('product-carousels')}>
      {carouselsData.map((carousel, index) => (
        <div className={styles.carousels} key={index}>
          <Carousel
            title={carousel.title}
            polaroidWidth={polaroidWidth}
            onScrollCallback={handleImageLazyLoading}
          >
            {carousel.artworks.map((artwork, index) => (
              <Polaroid
                key={index}
                polaroidRef={polaroidRef as RefObject<HTMLDivElement>}
                artwork={artwork}
                index={index}
                onImageClick={handleClick}
                onTitleClick={handleClick}
                listId={LIST_ID}
                listName={carousel.title}
                dataApi='palette'
                isLazyLoading={index > lastImageIndexLoaded}
              />
            ))}
            <SeeMoreTile
              link={carousel.collectionUrl}
              title={carousel.linkText}
              linkTitle={carousel.linkText}
            />
          </Carousel>
        </div>
      ))}
    </div>
  )
}

export default ProductCarousels
